import { createSlice } from '@reduxjs/toolkit'

const slice = createSlice({
  name: 'auth',
  initialState: {
    adminPharmacyAuth: false,
    token: '',
    loginError: '',
    loginLoading: false,
    PharmacyId: 0,
  },
  reducers: {
    fetchPharmacyUserLogin: (state) => {
      // let data = localStorage.getItem('adminPharmacyAuth')
      // let parsedData = JSON.parse(data)
      // state.adminPharmacyAuth = parsedData
      let data = localStorage.getItem('adminPharmacyAuth')
      let token = localStorage.getItem('adminPharmacyToken')
      const pharmacyExpirationDate = localStorage.getItem('pharmacyExpirationDate')
      if (!token || !pharmacyExpirationDate || !data) {
        return { ...state, adminPharmacyAuth: false, token: '' } // Set to false instead of null
      }
      const now = new Date()
      const expiry = new Date(pharmacyExpirationDate)
      if (now >= expiry) {
        localStorage.removeItem('adminPharmacyAuth')
        localStorage.removeItem('adminPharmacyToken')
        localStorage.removeItem('pharmacyExpirationDate')
        return { ...state, adminPharmacyAuth: false, token: '' } // Set to false instead of null
      }
      let parsedData = JSON.parse(data)
      return { ...state, adminPharmacyAuth: parsedData, token: token } // Return new state object
    },
    userPharmacyLogin: (state) => {
      state.loginLoading = true
      state.loginError = ''
    },
    userPharmacyLoginSuccess: (state, { payload: { payload } }) => {
      let data = JSON.stringify(payload?.data)
      state.PharmacyId = payload?.data?.id
      const now = new Date()
      const pharmacyExpirationDate = new Date(now.getTime() + 5 * 24 * 60 * 60 * 1000)
      localStorage.setItem('adminPharmacyAuth', data)
      localStorage.setItem('adminPharmacyToken', payload.data.access_token)
      localStorage.setItem('pharmacyExpirationDate', pharmacyExpirationDate.toISOString())
      state.loginLoading = false
      state.adminPharmacyAuth = payload.data
      state.token = payload.data.access_token
    },
    userPharmacyLoginFailed: (state, { payload }) => {
      state.token = '' // Use an empty string instead of null for consistency
      state.loginLoading = false
      state.loginError = payload.message
    },

    adminPharmacyLogoutFunc: (state) => {
      localStorage.removeItem('adminPharmacyAuth')
      localStorage.removeItem('adminPharmacyToken')
      localStorage.removeItem('pharmacyExpirationDate')
      return { ...state, adminPharmacyAuth: false, token: '' }
    },
  },
})

export const {
  adminPharmacyLogoutFunc,
  fetchPharmacyUserLogin,
  userPharmacyLogin,
  userPharmacyLoginFailed,
  userPharmacyLoginSuccess,
} = slice.actions

export default slice.reducer
